var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("   "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.tips,"placement":"bottom"}},[_c('i',{class:_vm.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }